// import TeamCard from "../../components/team-card/team-card.component";
import Shake from "react-reveal/Shake";
import Footer from "../../components/footer/footer.component";
import DevCard from "../../components/dev-card/dev-card.component";
import Jump from "react-reveal/Jump";
// import team from "../../team";
import AppButton from "../../components/app-button/app-button.component";
import { useNavigate } from "react-router-dom";

const portfolio = [
  {
    id: "1",
    name: "Ogun State Farmers Information Management System (OGFIMS)",
    link: "https://eshop.ogunfarminfo.org/",
    image: "ofims.png",
  },

  {
    id: "2",
    name: "Honour world Project –Digital Payments & Utility Services Platform",
    link: "http://lsvc.ng",
    image: "H-world.png",
  },

  {
    id: "3",
    name: "Lagos state performance tracker project.",
    link: "https://pmr-v2.vercel.app",
    image: "tracker.png",
  },

  {
    id: "4",
    name: "Restaurant and delivery system for a client in UK",
    link: "https://tastyhasty.co.uk/",
    image: "tastyhasty.png",
  },
  {
    id: "5",
    name: "Honor World mobile app",
    link: "https://play.google.com/store/apps/details?id=com.ng.honourworld&hl=en&gl=US",
    image: "honor-world.png",
  },
  {
    id: "6",
    name: "Traffic Age Project for Lagos Ride",
    link: "https://traffic-age.vercel.app/",
    image: "traffic-age.png",
  },
  {
    id: "7",
    name: "GIS Application for Dev Afrique (Bill and Melinda Gates Foundation) ",
    link: "https://www.geo-rolodex.com/",
    image: "rolodex.png",
  },
  {
    id: "8",
    name: "ESAWAS Data Maturity Assessment Platform",
    link: "https://icsacademy-student.vercel.app/",
    image: "esawas.png",
  },

  {
    id: "9",
    name: "Blog for Lagosride/ Lagride || Operating in Lagos",
    link: "https://lagosride.com",
    image: "lagride-blog.png",
  },
  {
    id: "10",
    name: "Lagos state performance tracker project",
    link: "https://pmr-v2.vercel.app",
    image: "pmr.png",
  },
  // {
  //   id: "16",
  //   name: "Restaurant and delivery system for a client in UK",
  //   link: "https://tastyhasty.co.uk ",
  //   image: "",
  // },
  {
    id: "11",
    name: "AI Model: Cancer Disease Detection for Ajayi Crowther University Student, Oyo Town.",
    link: "",
    image: "",
  },
  // {
  //   id: "18",
  //   name: "Sreenclass App for e-learning",
  //   link: "https://play.google.com/store/apps/details?id=com.screenclass&hl=en&gl=US",
  //   image: "",
  // },
  {
    id: "12",
    name: "Fruit Disease Detection for Food Science and Engineering Student, LAUTECH",
    link: "",
    image: "",
  },
  {
    id: "13",
    name: "Quiz application for EDTECH",
    link: "https://get-2-know.com/",
    image: "edtech.png",
  },
  {
    id: "14",
    name: "Ecommerce App Ileoja",
    link: "https://play.google.com/store/apps/details?id=com.ileoja.marketplace&hl=en&gl=US",
    image: "",
  },
  {
    id: "15",
    name: "Logistic Web APP",
    link: "http://www.viscio.com.ng/",
    image: "visco.png",
  },
  {
    id: "16",
    name: "Breast Cancer Disease Detection with AI/Machine Learning",
    link: "https://github.com/Lovej4972/BreastCancerDetection",
    image: "",
  },

  {
    id: "17",
    name: "Quotes connect procurement web app",
    link: "https://www.quotesconnect.com",
    image: "quotes-connect.png",
  },
  {
    id: "18",
    name: "School management system for a college in Ibadan.",
    link: "http://portal.guarverd.sch.ng/public",
    image: "guarverd.png",
  },
  {
    id: "19",
    name: "Sreenclass App for e-learning.",
    link: "https://play.google.com/store/apps/details?id=com.screenclass&hl=en&gl=US",
    image: "screenclass.png",
  },
  {
    id: "20",
    name: "LMS platform for BCT Limited",
    link: "https://www.mywebschools.com",
    image: "bct-lms.png",
  },
  {
    id: "21",
    name: "Grant application portal for Lagos state.",
    link: "https://grants.lsvc.ng/login",
    image: "sdg-grant.png",
  },
];

const Developers = () => {
  const navigate = useNavigate();
  const goToTeam = () => {
    navigate("/team");
  };
  return (
    <div>
      <section className="container mx-auto my-20 px-8 py-14 relative">
        <div className="absolute inset-0 top-120 rounded-md -z-20 overflow-hidden">
          <img
            src={require("../../assets/img/about-banner.jpg")}
            alt="affiliate-one"
            className="object-cover object-center rounded-md"
          />
        </div>

        <div className="bg-indigo-800 opacity-75 absolute inset-0 rounded-md -z-10"></div>
        <div className="">
          <div>
            <Shake>
              <p className="capitalize text-white text-4xl font-bold text-center mb-4 max-w-2xl mx-auto">
                Projects delivered by{" "}
                <span className="text-[#EFA632]">our expert developers</span>
              </p>
            </Shake>
            <p className="text-center text-white mt-2 text-sm w-4/5 md:w-3/4 mx-auto">
              Have a brilliant idea you want to transform into a software
              product or bring to life through digital technology? Our skilled
              developers are ready to turn your vision into reality—efficiently,
              creatively, and stress-free.
            </p>
            <div className="flex justify-center pt-8">
              <a href="https://wa.link/6wj4r8">
                <AppButton buttonType={"secondary"}>Hire us today</AppButton>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="banner container mx-auto mb-20 px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20">
          {portfolio.map((project) => (
            <DevCard
              id={project.id}
              img={project?.image}
              url={project?.link}
              title={project?.name}
            />
          ))}
        </div>
      </section>

      <div className="flex justify-center py-8">
        <a href="https://wa.link/6wj4r8">
          <AppButton
            buttonType={"primary"}
            children={" Hire us now"}
          />
        </a>
      </div>

      <div className=" flex justify-center py-8">
        <Jump>
          <AppButton
            children="Meet Our Team"
            buttonType="primary"
            handleButton={goToTeam}
          />
        </Jump>
      </div>

      <section>
        <Footer />
      </section>
    </div>
  );
};

export default Developers;
